import React, { useEffect, useState } from 'react';
import { AppStyles } from './styles/App';
import 'animate.css';
import { RALColors, options } from './_data';
import { GlobalStyles } from './styles';
import { IOption, MyContentWindow, modeStateType } from './_types';
import ToggleList from './components/ToggleList';
import MainModal from './components/MainModal';

const initState: modeStateType = {
  model: 'visionCorner', // ['basic', 'strong', 'visionCorner', 'panoramic', 'fullPanoramic']
  grassType: 'texturized', // ['monofilament', 'fibered', 'texturized']
  grassColor: '#3366ff',
  frameColor: '#0e0e0f',
  illuminationPillars: 'cShape', // ['none', 'cShape', 'vShape', 'straight']
  roofing: 'none', // ['none', 'cover', 'hangar']
  benches: 'none', // ['none', 'left', 'right', 'both']
  doorType: '2DoorNonProtection', // ['2DoorNonProtection', '2DoorProtection', 'slidingDoor', 'regularDoor']
  doorLocation: 'both', //['left', 'right', 'both'],
  interior: false,
  protection: [], //['left', 'right', 'back', 'front'],
  personalizedCorners: false,
  personalizedNet: false,
  personalizedCornersImage: '',
  // personalizedNetImage: '',
  // protection: {
  //   isEmpty: true,5
  //   left: false,
  //   right: false,
  //   back: false,
  //   front: false,
  // },
};

function App() {
  const [curIndex, setCurIndex] = useState<number>(0);
  const [optionValues, setOptionValues] = useState<IOption[]>(options);
  const [modelState, setModelState] = useState<modeStateType>(initState);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleUpdateState = (
    valueName: keyof modeStateType,
    valueData: string | number | boolean,
    file?: File
  ) => {
    const iframe = document.querySelector('#main-frame') as HTMLIFrameElement;
    if (iframe) {
      const windowFrame = iframe.contentWindow as MyContentWindow;
      if (windowFrame) {
        const procedures = windowFrame?.v3d?.puzzles?.procedures;
        if (procedures) {
          const capitalizedStr =
            valueName.charAt(0).toUpperCase() + valueName.slice(1);
          const puzzleFunc: string = 'change' + capitalizedStr;
          if (procedures[puzzleFunc]) {
            if (valueData === '#004f7b' || valueData === '#134333') {
              if (valueData === '#004f7b') {
                procedures[puzzleFunc]('#0071ae');
              } else if (valueData === '#134333') {
                procedures[puzzleFunc]('#008d5e');
              }
            } else {
              procedures[puzzleFunc](valueData);
            }
          }
          setModelState((oldState: modeStateType) => {
            if (valueName === 'protection') {
              let clonedProtection: (string | number | boolean)[] = [];
              if (valueData === 'none') {
                return { ...oldState, [valueName]: clonedProtection };
              } else if (valueData === 'all') {
                return {
                  ...oldState,
                  [valueName]: ['left', 'right', 'back', 'front'],
                };
              } else {
                clonedProtection = [...modelState.protection];
                const index = clonedProtection.findIndex(
                  (val) => val === valueData
                );
                if (index > -1) {
                  clonedProtection.splice(index, 1);
                } else {
                  clonedProtection.push(valueData);
                }
              }
              return { ...oldState, [valueName]: clonedProtection };
            } else {
              if (file) {
                return { ...oldState, [valueName]: file };
              } else {
                // if (
                //   valueName === 'model' &&
                //   (valueData === 'strong' ||
                //     valueData === 'visionCorner' ||
                //     valueData === 'panoramic')
                // ) {
                //   return { ...oldState, personalizedCorners: false };
                // }
                return { ...oldState, [valueName]: valueData };
              }
            }
          });
        }
      }
    }
  };

  const handleChangeIndex = (index: number) => {
    if (curIndex === index) {
      setCurIndex(-1);
    } else {
      setCurIndex(index);
    }
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    // window.addEventListener('scroll', function () {
    //   var element = document.getElementById('frame__container') as HTMLElement;
    //   var rect = element.getBoundingClientRect();
    //   // var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    //   // console.log(scrollTop);
    //   // console.log(rect);
    //   if (rect.top + 10 <= 0) {
    //     //(rect.top + scrollTop <= 0)
    //     element.classList.add('position__sticky');
    //   } else {
    //     element.classList.remove('position__sticky');
    //   }
    // });
  }, []);

  const findNameWithValue = (
    optionName: string,
    value: string | boolean | (string | number | boolean)[]
  ) => {
    let name = '';
    if (typeof value === 'string') {
      options.forEach((option: IOption) => {
        if (option.name === optionName) {
          option.data?.forEach((data) => {
            if (data.value === value) {
              name = data.name;
            }
          });
        }
      });
      if (optionName === 'frame color' && !name) {
        RALColors.forEach((color) => {
          if (color.hexValue === value) {
            name = color.name;
          }
        });
      }
    } else if (typeof value === 'boolean') {
      if (value) {
        name = 'Yes';
      } else {
        name = 'No';
      }
    } else if (Array.isArray(value)) {
      if (value.length === 0) {
        name = 'None';
      } else if (value.length === 4) {
        name = 'All';
      } else {
        value.forEach((val) => {
          options.forEach((option: IOption) => {
            if (option.name === optionName) {
              option.data?.forEach((data) => {
                if (data.value === val) {
                  name += data.name + ', ';
                }
              });
            }
          });
        });
        name = name.slice(0, -2);
      }
    }
    return (
      <div>
        <i className="fa-solid fa-arrow-right-long"></i> {name}
      </div>
    );
  };

  return (
    <AppStyles className="App">
      <GlobalStyles />
      <div className="app__container">
        <div
          id="frame__container"
          className="model__container position__sticky"
        >
          <iframe
            id="main-frame"
            className="main__frame"
            title="main-frame"
            src="./model3d/4292_Pista_padel/index.html"
          ></iframe>
        </div>
        <div className="configurator__container">
          <div className="configurator__main">
            <div className="confiurator__values__container">
              {optionValues?.map(
                (option: IOption, index: number, array: IOption[]) => {
                  const cornerChecking =
                    modelState.model === 'visionCorner' ||
                    modelState.model === 'fullPanoramic';
                  const cornerModelChecking = !(
                    option.value === 'personalizedCorners' && cornerChecking
                  );
                  let cornerIndex: number;
                  if (cornerModelChecking) {
                    cornerIndex = array.findIndex(
                      (option) => option.value === 'personalizedCorners'
                    );
                  } else {
                    cornerIndex = -1;
                  }
                  return (
                    <div
                      key={option?.name}
                      className={`option__container ${
                        cornerModelChecking ? '' : 'hidden'
                      }`}
                    >
                      <div className="option__main__container">
                        <div
                          className="toggle__tag"
                          onClick={() => handleChangeIndex(index)}
                        >
                          <span className="option__number">
                            {cornerIndex > -1 &&
                            cornerChecking &&
                            index > cornerIndex
                              ? index
                              : index + 1}
                          </span>
                          <span className="tag__text">
                            {option?.name.toUpperCase()}
                          </span>
                        </div>
                        <div
                          style={(() => {
                            const length = option?.data?.length;
                            let col = 3;
                            if (
                              option.selectionType === 'listOption' ||
                              option.selectionType === 'toggle-1' ||
                              option.selectionType === 'multi-dropdown'
                            ) {
                              col = 1;
                            }
                            const row = Math.ceil(
                              (length + 0) / col
                              // (length + (option.value === 'frameColor' ? 0 : 0)) / col
                            );
                            const height =
                              row * 55 +
                              59 +
                              (option.selectionType === 'multi-dropdown' ||
                              option.value === 'personalizedCorners'
                                ? // option.value === 'personalizedCorners' ||
                                  // option.value === 'personalizedNet'
                                  55
                                : 0) +
                              (option.value === 'frameColor' ? 56 : 0);
                            if (curIndex === index)
                              return {
                                height: height.toString() + 'px',
                              };
                            else return {};
                          })()}
                          className={`toggle__container ${
                            index === curIndex ? 'display' : ''
                          }`}
                        >
                          <ToggleList
                            handleUpdateState={handleUpdateState}
                            modelState={modelState}
                            value={option.value}
                            option={option}
                            type={option.selectionType}
                          ></ToggleList>
                          <div className="buttons__container">
                            {index > 0 ? (
                              <div
                                className="button__prev"
                                onClick={
                                  cornerChecking && cornerIndex === index - 1
                                    ? () => handleChangeIndex(index - 2)
                                    : () => handleChangeIndex(index - 1)
                                }
                              >
                                <i className="fa-solid fa-angle-up"></i>{' '}
                                previous
                              </div>
                            ) : (
                              ''
                            )}
                            {index < array.length - 1 ? (
                              <div
                                className="button__next"
                                onClick={
                                  cornerChecking && cornerIndex === index + 1
                                    ? () => handleChangeIndex(index + 2)
                                    : () => handleChangeIndex(index + 1)
                                }
                              >
                                next <i className="fa-solid fa-angle-down"></i>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        </div>
                        <div
                          className={`selecting__value ${
                            curIndex !== index ? 'show' : ''
                          }`}
                        >
                          {findNameWithValue(
                            option.name,
                            modelState[option.value]
                          )}
                        </div>
                      </div>
                    </div>
                  );
                }
              )}
            </div>
            <div className="submit__button__container">
              <button className="submit__button" onClick={handleShow}>
                Send Project
              </button>
            </div>
          </div>
          <>
            <MainModal
              state={modelState}
              show={show}
              handleClose={handleClose}
            ></MainModal>
          </>
        </div>
      </div>
    </AppStyles>
  );
}

export default App;
